module.exports = __webpack_public_path__ + "static/limpidmarkets-69931e032958dbbf1eebc52bd8eb862f.svg";